import * as Q from "react";
import Ge, { createContext as Rn, useContext as Cn, useState as q, useRef as te, useEffect as W, useCallback as Pe, useMemo as Tn } from "react";
import xn from "@arcgis/core/layers/GraphicsLayer.js";
import On from "@arcgis/core/Graphic";
import * as Sr from "@arcgis/core/geometry/support/jsonUtils";
import { useTranslation as Mn } from "react-i18next";
import { CalciteTooltip as Dn } from "@esri/calcite-components-react/dist";
import qt from "@arcgis/core/Map";
import Pn from "@arcgis/core/WebMap";
import An from "@arcgis/core/WebScene";
import Nn from "@arcgis/core/views/MapView";
import In from "@arcgis/core/views/SceneView";
import Z from "@arcgis/core/Basemap";
import me from "@arcgis/core/layers/VectorTileLayer";
import kr from "@arcgis/core/geometry/Point";
import { createLogger as Re } from "@origo/logger";
import jn from "@arcgis/core/layers/TileLayer";
import Ln from "@arcgis/core/layers/MapImageLayer";
import Vn from "@arcgis/core/layers/SceneLayer";
import Fn from "@arcgis/core/layers/ElevationLayer";
import zn from "@arcgis/core/Ground";
import $n from "@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource";
import Rr from "@arcgis/core/widgets/Search/LocatorSearchSource";
import Cr from "@arcgis/core/layers/FeatureLayer";
import Bn from "@arcgis/core/renderers/SimpleRenderer";
import Gn from "@arcgis/core/symbols/SimpleFillSymbol";
import * as re from "@arcgis/core/core/reactiveUtils";
import Wn from "@arcgis/core/widgets/Search";
import We from "@arcgis/core/widgets/Expand";
import Un from "@arcgis/core/widgets/BasemapGallery";
import Hn from "@arcgis/core/widgets/AreaMeasurement2D";
import Yn from "@arcgis/core/widgets/AreaMeasurement3D";
import Kn from "@arcgis/core/widgets/Daylight";
import Jn from "@arcgis/core/widgets/ShadowCast";
import qn from "@arcgis/core/widgets/Fullscreen";
import Xn from "@arcgis/core/widgets/ScaleBar";
import Le from "@arcgis/core/support/actions/ActionButton";
var pt = { exports: {} }, ve = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xt;
function Qn() {
  if (Xt)
    return ve;
  Xt = 1;
  var e = Ge, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(s, l, d) {
    var u, y = {}, _ = null, h = null;
    d !== void 0 && (_ = "" + d), l.key !== void 0 && (_ = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      n.call(l, u) && !a.hasOwnProperty(u) && (y[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        y[u] === void 0 && (y[u] = l[u]);
    return { $$typeof: t, type: s, key: _, ref: h, props: y, _owner: i.current };
  }
  return ve.Fragment = r, ve.jsx = c, ve.jsxs = c, ve;
}
var _e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qt;
function Zn() {
  return Qt || (Qt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ge, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, v = "@@iterator";
    function O(o) {
      if (o === null || typeof o != "object")
        return null;
      var f = m && o[m] || o[v];
      return typeof f == "function" ? f : null;
    }
    var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(o) {
      {
        for (var f = arguments.length, p = new Array(f > 1 ? f - 1 : 0), S = 1; S < f; S++)
          p[S - 1] = arguments[S];
        b("error", o, p);
      }
    }
    function b(o, f, p) {
      {
        var S = k.ReactDebugCurrentFrame, x = S.getStackAddendum();
        x !== "" && (f += "%s", p = p.concat([x]));
        var M = p.map(function(C) {
          return String(C);
        });
        M.unshift("Warning: " + f), Function.prototype.apply.call(console[o], console, M);
      }
    }
    var E = !1, w = !1, T = !1, D = !1, P = !1, U;
    U = Symbol.for("react.module.reference");
    function K(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === n || o === a || P || o === i || o === d || o === u || D || o === h || E || w || T || typeof o == "object" && o !== null && (o.$$typeof === _ || o.$$typeof === y || o.$$typeof === c || o.$$typeof === s || o.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === U || o.getModuleId !== void 0));
    }
    function le(o, f, p) {
      var S = o.displayName;
      if (S)
        return S;
      var x = f.displayName || f.name || "";
      return x !== "" ? p + "(" + x + ")" : p;
    }
    function he(o) {
      return o.displayName || "Context";
    }
    function B(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case s:
            var f = o;
            return he(f) + ".Consumer";
          case c:
            var p = o;
            return he(p._context) + ".Provider";
          case l:
            return le(o, o.render, "ForwardRef");
          case y:
            var S = o.displayName || null;
            return S !== null ? S : B(o.type) || "Memo";
          case _: {
            var x = o, M = x._payload, C = x._init;
            try {
              return B(C(M));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, H = 0, J, ue, de, Te, Pt, At, Nt;
    function It() {
    }
    It.__reactDisabledLog = !0;
    function Xr() {
      {
        if (H === 0) {
          J = console.log, ue = console.info, de = console.warn, Te = console.error, Pt = console.group, At = console.groupCollapsed, Nt = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: It,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        H++;
      }
    }
    function Qr() {
      {
        if (H--, H === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, o, {
              value: J
            }),
            info: N({}, o, {
              value: ue
            }),
            warn: N({}, o, {
              value: de
            }),
            error: N({}, o, {
              value: Te
            }),
            group: N({}, o, {
              value: Pt
            }),
            groupCollapsed: N({}, o, {
              value: At
            }),
            groupEnd: N({}, o, {
              value: Nt
            })
          });
        }
        H < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Je = k.ReactCurrentDispatcher, qe;
    function xe(o, f, p) {
      {
        if (qe === void 0)
          try {
            throw Error();
          } catch (x) {
            var S = x.stack.trim().match(/\n( *(at )?)/);
            qe = S && S[1] || "";
          }
        return `
` + qe + o;
      }
    }
    var Xe = !1, Oe;
    {
      var Zr = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new Zr();
    }
    function jt(o, f) {
      if (!o || Xe)
        return "";
      {
        var p = Oe.get(o);
        if (p !== void 0)
          return p;
      }
      var S;
      Xe = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var M;
      M = Je.current, Je.current = null, Xr();
      try {
        if (f) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (F) {
              S = F;
            }
            Reflect.construct(o, [], C);
          } else {
            try {
              C.call();
            } catch (F) {
              S = F;
            }
            o.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            S = F;
          }
          o();
        }
      } catch (F) {
        if (F && S && typeof F.stack == "string") {
          for (var R = F.stack.split(`
`), V = S.stack.split(`
`), A = R.length - 1, I = V.length - 1; A >= 1 && I >= 0 && R[A] !== V[I]; )
            I--;
          for (; A >= 1 && I >= 0; A--, I--)
            if (R[A] !== V[I]) {
              if (A !== 1 || I !== 1)
                do
                  if (A--, I--, I < 0 || R[A] !== V[I]) {
                    var G = `
` + R[A].replace(" at new ", " at ");
                    return o.displayName && G.includes("<anonymous>") && (G = G.replace("<anonymous>", o.displayName)), typeof o == "function" && Oe.set(o, G), G;
                  }
                while (A >= 1 && I >= 0);
              break;
            }
        }
      } finally {
        Xe = !1, Je.current = M, Qr(), Error.prepareStackTrace = x;
      }
      var pe = o ? o.displayName || o.name : "", ne = pe ? xe(pe) : "";
      return typeof o == "function" && Oe.set(o, ne), ne;
    }
    function en(o, f, p) {
      return jt(o, !1);
    }
    function tn(o) {
      var f = o.prototype;
      return !!(f && f.isReactComponent);
    }
    function Me(o, f, p) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return jt(o, tn(o));
      if (typeof o == "string")
        return xe(o);
      switch (o) {
        case d:
          return xe("Suspense");
        case u:
          return xe("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case l:
            return en(o.render);
          case y:
            return Me(o.type, f, p);
          case _: {
            var S = o, x = S._payload, M = S._init;
            try {
              return Me(M(x), f, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, Lt = {}, Vt = k.ReactDebugCurrentFrame;
    function De(o) {
      if (o) {
        var f = o._owner, p = Me(o.type, o._source, f ? f.type : null);
        Vt.setExtraStackFrame(p);
      } else
        Vt.setExtraStackFrame(null);
    }
    function rn(o, f, p, S, x) {
      {
        var M = Function.call.bind(ge);
        for (var C in o)
          if (M(o, C)) {
            var R = void 0;
            try {
              if (typeof o[C] != "function") {
                var V = Error((S || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              R = o[C](f, C, S, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              R = A;
            }
            R && !(R instanceof Error) && (De(x), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", p, C, typeof R), De(null)), R instanceof Error && !(R.message in Lt) && (Lt[R.message] = !0, De(x), g("Failed %s type: %s", p, R.message), De(null));
          }
      }
    }
    var nn = Array.isArray;
    function Qe(o) {
      return nn(o);
    }
    function on(o) {
      {
        var f = typeof Symbol == "function" && Symbol.toStringTag, p = f && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return p;
      }
    }
    function an(o) {
      try {
        return Ft(o), !1;
      } catch {
        return !0;
      }
    }
    function Ft(o) {
      return "" + o;
    }
    function zt(o) {
      if (an(o))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", on(o)), Ft(o);
    }
    var be = k.ReactCurrentOwner, sn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, $t, Bt, Ze;
    Ze = {};
    function cn(o) {
      if (ge.call(o, "ref")) {
        var f = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (f && f.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function ln(o) {
      if (ge.call(o, "key")) {
        var f = Object.getOwnPropertyDescriptor(o, "key").get;
        if (f && f.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function un(o, f) {
      if (typeof o.ref == "string" && be.current && f && be.current.stateNode !== f) {
        var p = B(be.current.type);
        Ze[p] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(be.current.type), o.ref), Ze[p] = !0);
      }
    }
    function dn(o, f) {
      {
        var p = function() {
          $t || ($t = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
        };
        p.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(o, f) {
      {
        var p = function() {
          Bt || (Bt = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
        };
        p.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(o, f, p, S, x, M, C) {
      var R = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: f,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: M
      };
      return R._store = {}, Object.defineProperty(R._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.defineProperty(R, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(R.props), Object.freeze(R)), R;
    };
    function mn(o, f, p, S, x) {
      {
        var M, C = {}, R = null, V = null;
        p !== void 0 && (zt(p), R = "" + p), ln(f) && (zt(f.key), R = "" + f.key), cn(f) && (V = f.ref, un(f, x));
        for (M in f)
          ge.call(f, M) && !sn.hasOwnProperty(M) && (C[M] = f[M]);
        if (o && o.defaultProps) {
          var A = o.defaultProps;
          for (M in A)
            C[M] === void 0 && (C[M] = A[M]);
        }
        if (R || V) {
          var I = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          R && dn(C, I), V && fn(C, I);
        }
        return pn(o, R, V, x, S, be.current, C);
      }
    }
    var et = k.ReactCurrentOwner, Gt = k.ReactDebugCurrentFrame;
    function fe(o) {
      if (o) {
        var f = o._owner, p = Me(o.type, o._source, f ? f.type : null);
        Gt.setExtraStackFrame(p);
      } else
        Gt.setExtraStackFrame(null);
    }
    var tt;
    tt = !1;
    function rt(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function Wt() {
      {
        if (et.current) {
          var o = B(et.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function yn(o) {
      {
        if (o !== void 0) {
          var f = o.fileName.replace(/^.*[\\\/]/, ""), p = o.lineNumber;
          return `

Check your code at ` + f + ":" + p + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function hn(o) {
      {
        var f = Wt();
        if (!f) {
          var p = typeof o == "string" ? o : o.displayName || o.name;
          p && (f = `

Check the top-level render call using <` + p + ">.");
        }
        return f;
      }
    }
    function Ht(o, f) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var p = hn(f);
        if (Ut[p])
          return;
        Ut[p] = !0;
        var S = "";
        o && o._owner && o._owner !== et.current && (S = " It was passed a child from " + B(o._owner.type) + "."), fe(o), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, S), fe(null);
      }
    }
    function Yt(o, f) {
      {
        if (typeof o != "object")
          return;
        if (Qe(o))
          for (var p = 0; p < o.length; p++) {
            var S = o[p];
            rt(S) && Ht(S, f);
          }
        else if (rt(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var x = O(o);
          if (typeof x == "function" && x !== o.entries)
            for (var M = x.call(o), C; !(C = M.next()).done; )
              rt(C.value) && Ht(C.value, f);
        }
      }
    }
    function gn(o) {
      {
        var f = o.type;
        if (f == null || typeof f == "string")
          return;
        var p;
        if (typeof f == "function")
          p = f.propTypes;
        else if (typeof f == "object" && (f.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        f.$$typeof === y))
          p = f.propTypes;
        else
          return;
        if (p) {
          var S = B(f);
          rn(p, o.props, "prop", S, o);
        } else if (f.PropTypes !== void 0 && !tt) {
          tt = !0;
          var x = B(f);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof f.getDefaultProps == "function" && !f.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function bn(o) {
      {
        for (var f = Object.keys(o.props), p = 0; p < f.length; p++) {
          var S = f[p];
          if (S !== "children" && S !== "key") {
            fe(o), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", S), fe(null);
            break;
          }
        }
        o.ref !== null && (fe(o), g("Invalid attribute `ref` supplied to `React.Fragment`."), fe(null));
      }
    }
    var Kt = {};
    function Jt(o, f, p, S, x, M) {
      {
        var C = K(o);
        if (!C) {
          var R = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (R += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = yn(x);
          V ? R += V : R += Wt();
          var A;
          o === null ? A = "null" : Qe(o) ? A = "array" : o !== void 0 && o.$$typeof === t ? (A = "<" + (B(o.type) || "Unknown") + " />", R = " Did you accidentally export a JSX literal instead of a component?") : A = typeof o, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, R);
        }
        var I = mn(o, f, p, x, M);
        if (I == null)
          return I;
        if (C) {
          var G = f.children;
          if (G !== void 0)
            if (S)
              if (Qe(G)) {
                for (var pe = 0; pe < G.length; pe++)
                  Yt(G[pe], o);
                Object.freeze && Object.freeze(G);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yt(G, o);
        }
        if (ge.call(f, "key")) {
          var ne = B(o), F = Object.keys(f).filter(function(kn) {
            return kn !== "key";
          }), nt = F.length > 0 ? "{key: someKey, " + F.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Kt[ne + nt]) {
            var Sn = F.length > 0 ? "{" + F.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nt, ne, Sn, ne), Kt[ne + nt] = !0;
          }
        }
        return o === n ? bn(I) : gn(I), I;
      }
    }
    function vn(o, f, p) {
      return Jt(o, f, p, !0);
    }
    function _n(o, f, p) {
      return Jt(o, f, p, !1);
    }
    var En = _n, wn = vn;
    _e.Fragment = n, _e.jsx = En, _e.jsxs = wn;
  }()), _e;
}
process.env.NODE_ENV === "production" ? pt.exports = Qn() : pt.exports = Zn();
var X = pt.exports;
const eo = (e) => e.type ? e : Sr.fromJSON(e), to = (e, t, r) => {
  const n = eo(e);
  if (!n)
    throw new Error("Invalid geometry provided.");
  return e = n, new On({
    geometry: e,
    attributes: r,
    symbol: t
  });
}, ro = 400, no = "ease-out", oo = 250, io = () => typeof window < "u" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
function ao(e, t, r, n) {
  const i = 3 * e, a = 3 * (r - e) - i, c = 1 - i - a, s = 3 * t, l = 3 * (n - t) - s, d = 1 - s - l, u = (m) => ((c * m + a) * m + i) * m, y = (m) => ((d * m + l) * m + s) * m, _ = (m) => (3 * c * m + 2 * a) * m + i;
  function h(m) {
    let v = m;
    for (let g = 0; g < 8; g++) {
      const b = u(v) - m;
      if (Math.abs(b) < 1e-6)
        return v;
      const E = _(v);
      if (Math.abs(E) < 1e-6)
        break;
      v -= b / E;
    }
    let O = 0, k = 1;
    for (v = m; O < k; ) {
      const g = u(v);
      if (Math.abs(g - m) < 1e-6)
        return v;
      m > g ? O = v : k = v, v = (k - O) / 2 + O;
    }
    return v;
  }
  return (m) => y(h(m));
}
const so = ao(0.2, 0, 0, 1), ee = /* @__PURE__ */ new WeakMap(), co = (e) => e.padding?.bottom ?? 0, Ve = (e, t) => {
  e.padding = { ...e.padding, bottom: t };
};
function lo(e, t) {
  ee.get(e)?.cancel(), ee.delete(e), Ve(e, t);
}
function uo(e) {
  const t = ee.get(e);
  t && (t.cancel(), ee.delete(e), Ve(e, t.target));
}
function fo(e, t) {
  if (ee.get(e)?.cancel(), io()) {
    ee.delete(e), Ve(e, t);
    return;
  }
  const r = co(e), n = performance.now();
  let i = !1, a;
  const c = (s) => {
    if (i)
      return;
    const l = Math.min(1, (s - n) / oo);
    Ve(e, r + (t - r) * so(l)), l < 1 ? a = requestAnimationFrame(c) : ee.delete(e);
  };
  ee.set(e, {
    target: t,
    cancel: () => {
      i = !0, cancelAnimationFrame(a);
    }
  }), a = requestAnimationFrame(c);
}
function po(e, t, r) {
  if (e)
    return uo(e), e.goTo(t, { duration: ro, easing: no, ...r });
}
const ot = {
  ID: "highlight_layer",
  LIST_MODE: "hide",
  VISIBLE: !0
}, Zt = (e, t) => {
  e?.map?.add(t);
}, er = (e, t) => {
  e?.map?.layers.includes(t) && e.map.remove(t);
}, tr = (e, t) => e || t, mo = (e, t) => e.map((r) => to(r, t));
var Fe = /* @__PURE__ */ ((e) => (e.TwoD = "2D", e.ThreeD = "3D", e))(Fe || {});
const Tr = Rn({
  mapView: null,
  setMapView: () => {
  },
  sceneView: null,
  setSceneView: () => {
  },
  highlightGeometries: () => {
  },
  clearHighlights: () => {
  },
  graphicsLayer: null,
  currentHighlights: null,
  currentSymbol: null,
  onMapClick: void 0,
  // Default values for new properties
  mapMode: "2D",
  setMapMode: () => {
  },
  toggleMapMode: () => {
  },
  widgetConfig: void 0,
  setWidgetConfig: () => {
  },
  disableMapClick: !1,
  setDisableMapClick: () => {
  },
  setBottomInset: () => {
  },
  onLocationChange: void 0,
  onWidgetActivation: void 0
}), yo = () => Cn(Tr), Ua = ({
  children: e,
  onMapClick: t,
  onLocationChange: r,
  onWidgetActivation: n,
  initialMapMode: i = "2D",
  widgetConfig: a
}) => {
  const [c, s] = q(null), [l, d] = q(null), [u, y] = q(null), [_, h] = q(null), [m, v] = q(null), [O, k] = q(i), [g, b] = q(a || {}), [E, w] = q(!1), T = te(null), D = te(null), P = te(null);
  W(() => {
    T.current = u;
  }, [u]), W(() => {
    D.current = c;
  }, [c]), W(() => {
    P.current = l;
  }, [l]), W(() => {
    const N = new xn({
      id: ot.ID,
      listMode: ot.LIST_MODE,
      visible: ot.VISIBLE
    });
    y(N);
  }, []), W(() => {
    if (u)
      return Zt(c, u), Zt(l, u), () => {
        er(c, u), er(l, u);
      };
  }, [c, l, u]);
  const U = Pe((N, H, J = !1) => {
    const ue = T.current;
    if (!ue)
      return;
    h(N), v(H), ue.removeAll();
    const de = mo(N, H);
    if (ue.addMany(de), J && de.length > 0) {
      const Te = tr(D.current, P.current);
      po(Te, de);
    }
  }, []), K = Pe(() => {
    const N = T.current;
    N && (N.removeAll(), h(null), v(null));
  }, []), le = Pe(() => {
    k(
      (N) => N === "2D" ? "3D" : "2D"
      /* TwoD */
    );
  }, []), he = Pe((N, H) => {
    const J = tr(D.current, P.current);
    J && (H?.immediate ? lo(J, N) : fo(J, N));
  }, []), B = Tn(() => ({
    mapView: c,
    setMapView: s,
    sceneView: l,
    setSceneView: d,
    highlightGeometries: U,
    clearHighlights: K,
    graphicsLayer: u,
    currentHighlights: _,
    currentSymbol: m,
    onMapClick: t,
    mapMode: O,
    setMapMode: k,
    toggleMapMode: le,
    widgetConfig: g,
    setWidgetConfig: b,
    disableMapClick: E,
    setDisableMapClick: w,
    setBottomInset: he,
    onLocationChange: r,
    onWidgetActivation: n
  }), [
    c,
    l,
    U,
    K,
    u,
    _,
    m,
    t,
    O,
    le,
    g,
    E,
    he,
    r,
    n
  ]);
  return /* @__PURE__ */ X.jsx(Tr.Provider, { value: B, children: e });
}, kt = [0, 55, 248];
function Rt(e, t) {
  if (typeof document > "u")
    return t;
  const r = getComputedStyle(document.documentElement).getPropertyValue(e).trim();
  if (!r)
    return t;
  const n = r.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (n) {
    const a = n[1].length === 3 ? n[1].split("").map((s) => s + s).join("") : n[1], c = parseInt(a, 16);
    return [c >> 16 & 255, c >> 8 & 255, c & 255];
  }
  const i = r.match(/rgba?\s*\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i);
  return i ? [Number(i[1]), Number(i[2]), Number(i[3])] : t;
}
function Ha() {
  const [e, t, r] = Rt("--map-selection", kt);
  return {
    type: "simple-fill",
    color: [e, t, r, 0.12],
    outline: {
      color: [e, t, r, 1],
      width: 2
    }
  };
}
function Ya() {
  const [e, t, r] = Rt("--map-selection", kt);
  return {
    type: "simple-marker",
    color: [e, t, r, 1],
    size: 10,
    outline: {
      color: [255, 255, 255, 1],
      width: 2
    }
  };
}
function Ka() {
  return {
    type: "simple-fill",
    color: [255, 255, 0, 0.3],
    outline: {
      color: [255, 0, 0, 1],
      width: 2
    }
  };
}
function Ja() {
  const [e, t, r] = Rt("--map-selection", kt);
  return {
    type: "simple-fill",
    color: [0, 0, 0, 0],
    outline: {
      style: "short-dash",
      color: [e, t, r, 0.7],
      width: 1.5
    }
  };
}
var mt = { exports: {} }, it = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rr;
function ho() {
  if (rr)
    return it;
  rr = 1;
  var e = Ge;
  function t(l, d) {
    return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useSyncExternalStore, i = e.useRef, a = e.useEffect, c = e.useMemo, s = e.useDebugValue;
  return it.useSyncExternalStoreWithSelector = function(l, d, u, y, _) {
    var h = i(null);
    if (h.current === null) {
      var m = { hasValue: !1, value: null };
      h.current = m;
    } else
      m = h.current;
    h = c(
      function() {
        function O(w) {
          if (!k) {
            if (k = !0, g = w, w = y(w), _ !== void 0 && m.hasValue) {
              var T = m.value;
              if (_(T, w))
                return b = T;
            }
            return b = w;
          }
          if (T = b, r(g, w))
            return T;
          var D = y(w);
          return _ !== void 0 && _(T, D) ? (g = w, T) : (g = w, b = D);
        }
        var k = !1, g, b, E = u === void 0 ? null : u;
        return [
          function() {
            return O(d());
          },
          E === null ? void 0 : function() {
            return O(E());
          }
        ];
      },
      [d, u, y, _]
    );
    var v = n(l, h[0], h[1]);
    return a(
      function() {
        m.hasValue = !0, m.value = v;
      },
      [v]
    ), s(v), v;
  }, it;
}
var at = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nr;
function go() {
  return nr || (nr = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, d) {
      return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Ge, r = typeof Object.is == "function" ? Object.is : e, n = t.useSyncExternalStore, i = t.useRef, a = t.useEffect, c = t.useMemo, s = t.useDebugValue;
    at.useSyncExternalStoreWithSelector = function(l, d, u, y, _) {
      var h = i(null);
      if (h.current === null) {
        var m = { hasValue: !1, value: null };
        h.current = m;
      } else
        m = h.current;
      h = c(
        function() {
          function O(w) {
            if (!k) {
              if (k = !0, g = w, w = y(w), _ !== void 0 && m.hasValue) {
                var T = m.value;
                if (_(T, w))
                  return b = T;
              }
              return b = w;
            }
            if (T = b, r(g, w))
              return T;
            var D = y(w);
            return _ !== void 0 && _(T, D) ? (g = w, T) : (g = w, b = D);
          }
          var k = !1, g, b, E = u === void 0 ? null : u;
          return [
            function() {
              return O(d());
            },
            E === null ? void 0 : function() {
              return O(E());
            }
          ];
        },
        [d, u, y, _]
      );
      var v = n(l, h[0], h[1]);
      return a(
        function() {
          m.hasValue = !0, m.value = v;
        },
        [v]
      ), s(v), v;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), at;
}
process.env.NODE_ENV === "production" ? mt.exports = ho() : mt.exports = go();
var bo = mt.exports, st = /* @__PURE__ */ Symbol.for("react-redux-context"), ct = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function vo() {
  if (!Q.createContext)
    return {};
  const e = ct[st] ?? (ct[st] = /* @__PURE__ */ new Map());
  let t = e.get(Q.createContext);
  return t || (t = Q.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(Q.createContext, t)), t;
}
var ae = /* @__PURE__ */ vo();
function Ct(e = ae) {
  return function() {
    const r = Q.useContext(e);
    if (process.env.NODE_ENV !== "production" && !r)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return r;
  };
}
var xr = /* @__PURE__ */ Ct();
function Or(e = ae) {
  const t = e === ae ? xr : (
    // @ts-ignore
    Ct(e)
  ), r = () => {
    const { store: n } = t();
    return n;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var _o = /* @__PURE__ */ Or();
function Eo(e = ae) {
  const t = e === ae ? _o : Or(e), r = () => t().dispatch;
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var wo = /* @__PURE__ */ Eo(), So = (e, t) => e === t;
function ko(e = ae) {
  const t = e === ae ? xr : Ct(e), r = (n, i = {}) => {
    const { equalityFn: a = So } = typeof i == "function" ? { equalityFn: i } : i;
    if (process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof a != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const c = t(), { store: s, subscription: l, getServerState: d } = c, u = Q.useRef(!0), y = Q.useCallback(
      {
        [n.name](h) {
          const m = n(h);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks: v = {} } = typeof i == "function" ? {} : i, { identityFunctionCheck: O, stabilityCheck: k } = c, {
              identityFunctionCheck: g,
              stabilityCheck: b
            } = {
              stabilityCheck: k,
              identityFunctionCheck: O,
              ...v
            };
            if (b === "always" || b === "once" && u.current) {
              const E = n(h);
              if (!a(m, E)) {
                let w;
                try {
                  throw new Error();
                } catch (T) {
                  ({ stack: w } = T);
                }
                console.warn(
                  "Selector " + (n.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: h,
                    selected: m,
                    selected2: E,
                    stack: w
                  }
                );
              }
            }
            if ((g === "always" || g === "once" && u.current) && m === h) {
              let E;
              try {
                throw new Error();
              } catch (w) {
                ({ stack: E } = w);
              }
              console.warn(
                "Selector " + (n.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: E }
              );
            }
            u.current && (u.current = !1);
          }
          return m;
        }
      }[n.name],
      [n]
    ), _ = bo.useSyncExternalStoreWithSelector(
      l.addNestedSub,
      s.getState,
      d || s.getState,
      y,
      a
    );
    return Q.useDebugValue(_), _;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var yt = /* @__PURE__ */ ko(), lt = () => Math.random().toString(36).substring(7).split("").join(".");
`${lt()}`, `${lt()}`;
function Ro(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function Co(e) {
  return Ro(e) && "type" in e && typeof e.type == "string";
}
var Mr = Symbol.for("immer-nothing"), or = Symbol.for("immer-draftable"), $ = Symbol.for("immer-state"), To = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function z(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = To[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var we = Object.getPrototypeOf;
function se(e) {
  return !!e && !!e[$];
}
function Y(e) {
  return e ? Dr(e) || Array.isArray(e) || !!e[or] || !!e.constructor?.[or] || Ce(e) || He(e) : !1;
}
var xo = Object.prototype.constructor.toString(), ir = /* @__PURE__ */ new WeakMap();
function Dr(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null || t === Object.prototype)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  if (r === Object)
    return !0;
  if (typeof r != "function")
    return !1;
  let n = ir.get(r);
  return n === void 0 && (n = Function.toString.call(r), ir.set(r, n)), n === xo;
}
function ze(e, t, r = !0) {
  Ue(e) === 0 ? (r ? Reflect.ownKeys(e) : Object.keys(e)).forEach((i) => {
    t(i, e[i], e);
  }) : e.forEach((n, i) => t(i, n, e));
}
function Ue(e) {
  const t = e[$];
  return t ? t.type_ : Array.isArray(e) ? 1 : Ce(e) ? 2 : He(e) ? 3 : 0;
}
function ht(e, t) {
  return Ue(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Pr(e, t, r) {
  const n = Ue(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function Oo(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Ce(e) {
  return e instanceof Map;
}
function He(e) {
  return e instanceof Set;
}
function ie(e) {
  return e.copy_ || e.base_;
}
function gt(e, t) {
  if (Ce(e))
    return new Map(e);
  if (He(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = Dr(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[$];
    let i = Reflect.ownKeys(n);
    for (let a = 0; a < i.length; a++) {
      const c = i[a], s = n[c];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (n[c] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: e[c]
      });
    }
    return Object.create(we(e), n);
  } else {
    const n = we(e);
    if (n !== null && r)
      return { ...e };
    const i = Object.create(n);
    return Object.assign(i, e);
  }
}
function Tt(e, t = !1) {
  return Ye(e) || se(e) || !Y(e) || (Ue(e) > 1 && Object.defineProperties(e, {
    set: Ae,
    add: Ae,
    clear: Ae,
    delete: Ae
  }), Object.freeze(e), t && Object.values(e).forEach((r) => Tt(r, !0))), e;
}
function Mo() {
  z(2);
}
var Ae = {
  value: Mo
};
function Ye(e) {
  return e === null || typeof e != "object" ? !0 : Object.isFrozen(e);
}
var Do = {};
function ce(e) {
  const t = Do[e];
  return t || z(0, e), t;
}
var Se;
function Ar() {
  return Se;
}
function Po(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function ar(e, t) {
  t && (ce("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function bt(e) {
  vt(e), e.drafts_.forEach(Ao), e.drafts_ = null;
}
function vt(e) {
  e === Se && (Se = e.parent_);
}
function sr(e) {
  return Se = Po(Se, e);
}
function Ao(e) {
  const t = e[$];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function cr(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[$].modified_ && (bt(t), z(4)), Y(e) && (e = $e(t, e), t.parent_ || Be(t, e)), t.patches_ && ce("Patches").generateReplacementPatches_(
    r[$].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = $e(t, r, []), bt(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Mr ? e : void 0;
}
function $e(e, t, r) {
  if (Ye(t))
    return t;
  const n = e.immer_.shouldUseStrictIteration(), i = t[$];
  if (!i)
    return ze(
      t,
      (a, c) => lr(e, i, t, a, c, r),
      n
    ), t;
  if (i.scope_ !== e)
    return t;
  if (!i.modified_)
    return Be(e, i.base_, !0), i.base_;
  if (!i.finalized_) {
    i.finalized_ = !0, i.scope_.unfinalizedDrafts_--;
    const a = i.copy_;
    let c = a, s = !1;
    i.type_ === 3 && (c = new Set(a), a.clear(), s = !0), ze(
      c,
      (l, d) => lr(
        e,
        i,
        a,
        l,
        d,
        r,
        s
      ),
      n
    ), Be(e, a, !1), r && e.patches_ && ce("Patches").generatePatches_(
      i,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return i.copy_;
}
function lr(e, t, r, n, i, a, c) {
  if (i == null || typeof i != "object" && !c)
    return;
  const s = Ye(i);
  if (!(s && !c)) {
    if (process.env.NODE_ENV !== "production" && i === r && z(5), se(i)) {
      const l = a && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
      !ht(t.assigned_, n) ? a.concat(n) : void 0, d = $e(e, i, l);
      if (Pr(r, n, d), se(d))
        e.canAutoFreeze_ = !1;
      else
        return;
    } else
      c && r.add(i);
    if (Y(i) && !s) {
      if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[n] === i && s)
        return;
      $e(e, i), (!t || !t.scope_.parent_) && typeof n != "symbol" && (Ce(r) ? r.has(n) : Object.prototype.propertyIsEnumerable.call(r, n)) && Be(e, i);
    }
  }
}
function Be(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Tt(t, r);
}
function No(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Ar(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = n, a = xt;
  r && (i = [n], a = ke);
  const { revoke: c, proxy: s } = Proxy.revocable(i, a);
  return n.draft_ = s, n.revoke_ = c, s;
}
var xt = {
  get(e, t) {
    if (t === $)
      return e;
    const r = ie(e);
    if (!ht(r, t))
      return Io(e, r, t);
    const n = r[t];
    return e.finalized_ || !Y(n) ? n : n === ut(e.base_, t) ? (dt(e), e.copy_[t] = Et(n, e)) : n;
  },
  has(e, t) {
    return t in ie(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(ie(e));
  },
  set(e, t, r) {
    const n = Nr(ie(e), t);
    if (n?.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const i = ut(ie(e), t), a = i?.[$];
      if (a && a.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (Oo(r, i) && (r !== void 0 || ht(e.base_, t)))
        return !0;
      dt(e), _t(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return ut(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, dt(e), _t(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = ie(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    z(11);
  },
  getPrototypeOf(e) {
    return we(e.base_);
  },
  setPrototypeOf() {
    z(12);
  }
}, ke = {};
ze(xt, (e, t) => {
  ke[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
ke.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && z(13), ke.set.call(this, e, t, void 0);
};
ke.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && z(14), xt.set.call(this, e[0], t, r, e[0]);
};
function ut(e, t) {
  const r = e[$];
  return (r ? ie(r) : e)[t];
}
function Io(e, t, r) {
  const n = Nr(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    n.get?.call(e.draft_)
  ) : void 0;
}
function Nr(e, t) {
  if (!(t in e))
    return;
  let r = we(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = we(r);
  }
}
function _t(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && _t(e.parent_));
}
function dt(e) {
  e.copy_ || (e.copy_ = gt(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var jo = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const a = r;
        r = t;
        const c = this;
        return function(l = a, ...d) {
          return c.produce(l, (u) => r.call(this, u, ...d));
        };
      }
      typeof r != "function" && z(6), n !== void 0 && typeof n != "function" && z(7);
      let i;
      if (Y(t)) {
        const a = sr(this), c = Et(t, void 0);
        let s = !0;
        try {
          i = r(c), s = !1;
        } finally {
          s ? bt(a) : vt(a);
        }
        return ar(a, n), cr(i, a);
      } else if (!t || typeof t != "object") {
        if (i = r(t), i === void 0 && (i = t), i === Mr && (i = void 0), this.autoFreeze_ && Tt(i, !0), n) {
          const a = [], c = [];
          ce("Patches").generateReplacementPatches_(t, i, a, c), n(a, c);
        }
        return i;
      } else
        z(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (c, ...s) => this.produceWithPatches(c, (l) => t(l, ...s));
      let n, i;
      return [this.produce(t, r, (c, s) => {
        n = c, i = s;
      }), n, i];
    }, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy), typeof e?.useStrictIteration == "boolean" && this.setUseStrictIteration(e.useStrictIteration);
  }
  createDraft(e) {
    Y(e) || z(8), se(e) && (e = Ir(e));
    const t = sr(this), r = Et(e, void 0);
    return r[$].isManual_ = !0, vt(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[$];
    (!r || !r.isManual_) && z(9);
    const { scope_: n } = r;
    return ar(n, t), cr(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(e) {
    this.useStrictIteration_ = e;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const i = t[r];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = ce("Patches").applyPatches_;
    return se(e) ? n(e, t) : this.produce(
      e,
      (i) => n(i, t)
    );
  }
};
function Et(e, t) {
  const r = Ce(e) ? ce("MapSet").proxyMap_(e, t) : He(e) ? ce("MapSet").proxySet_(e, t) : No(e, t);
  return (t ? t.scope_ : Ar()).drafts_.push(r), r;
}
function Ir(e) {
  return se(e) || z(10, e), jr(e);
}
function jr(e) {
  if (!Y(e) || Ye(e))
    return e;
  const t = e[$];
  let r, n = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = gt(e, t.scope_.immer_.useStrictShallowCopy_), n = t.scope_.immer_.shouldUseStrictIteration();
  } else
    r = gt(e, !0);
  return ze(
    r,
    (i, a) => {
      Pr(r, i, jr(a));
    },
    n
  ), t && (t.finalized_ = !1), r;
}
var wt = new jo(), Lr = wt.produce, Lo = /* @__PURE__ */ wt.setUseStrictIteration.bind(
  wt
), Vo = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const i = {};
      e(i) === i && (n = !0);
    } catch {
    }
    if (n) {
      let i;
      try {
        throw new Error();
      } catch (a) {
        ({ stack: i } = a);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, Fo = (e, t, r) => {
  const { memoize: n, memoizeOptions: i } = t, { inputSelectorResults: a, inputSelectorResultsCopy: c } = e, s = n(() => ({}), ...i);
  if (!(s.apply(null, a) === s.apply(null, c))) {
    let d;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: d } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: a,
        secondInputs: c,
        stack: d
      }
    );
  }
}, zo = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function $o(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function Bo(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function Go(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var ur = (e) => Array.isArray(e) ? e : [e];
function Wo(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Go(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function dr(e, t) {
  const r = [], { length: n } = e;
  for (let i = 0; i < n; i++)
    r.push(e[i].apply(null, t));
  return r;
}
var Uo = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...zo,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: Vo
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: Fo
    }
  };
}, Ho = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Yo = typeof WeakRef < "u" ? WeakRef : Ho, Ko = 0, fr = 1;
function Ne() {
  return {
    s: Ko,
    v: void 0,
    o: null,
    p: null
  };
}
function Vr(e, t = {}) {
  let r = Ne();
  const { resultEqualityCheck: n } = t;
  let i, a = 0;
  function c() {
    let s = r;
    const { length: l } = arguments;
    for (let y = 0, _ = l; y < _; y++) {
      const h = arguments[y];
      if (typeof h == "function" || typeof h == "object" && h !== null) {
        let m = s.o;
        m === null && (s.o = m = /* @__PURE__ */ new WeakMap());
        const v = m.get(h);
        v === void 0 ? (s = Ne(), m.set(h, s)) : s = v;
      } else {
        let m = s.p;
        m === null && (s.p = m = /* @__PURE__ */ new Map());
        const v = m.get(h);
        v === void 0 ? (s = Ne(), m.set(h, s)) : s = v;
      }
    }
    const d = s;
    let u;
    if (s.s === fr)
      u = s.v;
    else if (u = e.apply(null, arguments), a++, n) {
      const y = i?.deref?.() ?? i;
      y != null && n(y, u) && (u = y, a !== 0 && a--), i = typeof u == "object" && u !== null || typeof u == "function" ? new Yo(u) : u;
    }
    return d.s = fr, d.v = u, u;
  }
  return c.clearCache = () => {
    r = Ne(), c.resetResultsCount();
  }, c.resultsCount = () => a, c.resetResultsCount = () => {
    a = 0;
  }, c;
}
function Jo(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...i) => {
    let a = 0, c = 0, s, l = {}, d = i.pop();
    typeof d == "object" && (l = d, d = i.pop()), $o(
      d,
      `createSelector expects an output function after the inputs, but received: [${typeof d}]`
    );
    const u = {
      ...r,
      ...l
    }, {
      memoize: y,
      memoizeOptions: _ = [],
      argsMemoize: h = Vr,
      argsMemoizeOptions: m = [],
      devModeChecks: v = {}
    } = u, O = ur(_), k = ur(m), g = Wo(i), b = y(function() {
      return a++, d.apply(
        null,
        arguments
      );
    }, ...O);
    let E = !0;
    const w = h(function() {
      c++;
      const D = dr(
        g,
        arguments
      );
      if (s = b.apply(null, D), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: P, inputStabilityCheck: U } = Uo(E, v);
        if (P.shouldRun && P.run(
          d,
          D,
          s
        ), U.shouldRun) {
          const K = dr(
            g,
            arguments
          );
          U.run(
            { inputSelectorResults: D, inputSelectorResultsCopy: K },
            { memoize: y, memoizeOptions: O },
            arguments
          );
        }
        E && (E = !1);
      }
      return s;
    }, ...k);
    return Object.assign(w, {
      resultFunc: d,
      memoizedResultFunc: b,
      dependencies: g,
      dependencyRecomputations: () => c,
      resetDependencyRecomputations: () => {
        c = 0;
      },
      lastResult: () => s,
      recomputations: () => a,
      resetRecomputations: () => {
        a = 0;
      },
      memoize: y,
      argsMemoize: h
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Ot = /* @__PURE__ */ Jo(Vr), qo = Object.assign(
  (e, t = Ot) => {
    Bo(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const r = Object.keys(e), n = r.map(
      (a) => e[a]
    );
    return t(
      n,
      (...a) => a.reduce((c, s, l) => (c[r[l]] = s, c), {})
    );
  },
  { withTypes: () => qo }
);
function pr(e, t) {
  function r(...n) {
    if (t) {
      let i = t(...n);
      if (!i)
        throw new Error(process.env.NODE_ENV === "production" ? L(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: i.payload,
        ..."meta" in i && {
          meta: i.meta
        },
        ..."error" in i && {
          error: i.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return r.toString = () => `${e}`, r.type = e, r.match = (n) => Co(n) && n.type === e, r;
}
function mr(e) {
  return Y(e) ? Lr(e, () => {
  }) : e;
}
function Ie(e, t, r) {
  return e.has(t) ? e.get(t) : e.set(t, r(t)).get(t);
}
function Fr(e) {
  const t = {}, r = [];
  let n;
  const i = {
    addCase(a, c) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? L(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error(process.env.NODE_ENV === "production" ? L(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const s = typeof a == "string" ? a : a.type;
      if (!s)
        throw new Error(process.env.NODE_ENV === "production" ? L(28) : "`builder.addCase` cannot be called with an empty action type");
      if (s in t)
        throw new Error(process.env.NODE_ENV === "production" ? L(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${s}'`);
      return t[s] = c, i;
    },
    addAsyncThunk(a, c) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
      return c.pending && (t[a.pending.type] = c.pending), c.rejected && (t[a.rejected.type] = c.rejected), c.fulfilled && (t[a.fulfilled.type] = c.fulfilled), c.settled && r.push({
        matcher: a.settled,
        reducer: c.settled
      }), i;
    },
    addMatcher(a, c) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: a,
        reducer: c
      }), i;
    },
    addDefaultCase(a) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(31) : "`builder.addDefaultCase` can only be called once");
      return n = a, i;
    }
  };
  return e(i), [t, r, n];
}
Lo(!1);
function Xo(e) {
  return typeof e == "function";
}
function Qo(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? L(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, n, i] = Fr(t), a;
  if (Xo(e))
    a = () => mr(e());
  else {
    const s = mr(e);
    a = () => s;
  }
  function c(s = a(), l) {
    let d = [r[l.type], ...n.filter(({
      matcher: u
    }) => u(l)).map(({
      reducer: u
    }) => u)];
    return d.filter((u) => !!u).length === 0 && (d = [i]), d.reduce((u, y) => {
      if (y)
        if (se(u)) {
          const h = y(u, l);
          return h === void 0 ? u : h;
        } else {
          if (Y(u))
            return Lr(u, (_) => y(_, l));
          {
            const _ = y(u, l);
            if (_ === void 0) {
              if (u === null)
                return u;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return _;
          }
        }
      return u;
    }, s);
  }
  return c.getInitialState = a, c;
}
var Zo = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function ei(e, t) {
  return `${e}/${t}`;
}
function ti({
  creators: e
} = {}) {
  const t = e?.asyncThunk?.[Zo];
  return function(n) {
    const {
      name: i,
      reducerPath: a = i
    } = n;
    if (!i)
      throw new Error(process.env.NODE_ENV === "production" ? L(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && n.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const c = (typeof n.reducers == "function" ? n.reducers(oi()) : n.reducers) || {}, s = Object.keys(c), l = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, d = {
      addCase(b, E) {
        const w = typeof b == "string" ? b : b.type;
        if (!w)
          throw new Error(process.env.NODE_ENV === "production" ? L(12) : "`context.addCase` cannot be called with an empty action type");
        if (w in l.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? L(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + w);
        return l.sliceCaseReducersByType[w] = E, d;
      },
      addMatcher(b, E) {
        return l.sliceMatchers.push({
          matcher: b,
          reducer: E
        }), d;
      },
      exposeAction(b, E) {
        return l.actionCreators[b] = E, d;
      },
      exposeCaseReducer(b, E) {
        return l.sliceCaseReducersByName[b] = E, d;
      }
    };
    s.forEach((b) => {
      const E = c[b], w = {
        reducerName: b,
        type: ei(i, b),
        createNotation: typeof n.reducers == "function"
      };
      ai(E) ? ci(w, E, d, t) : ii(w, E, d);
    });
    function u() {
      if (process.env.NODE_ENV !== "production" && typeof n.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? L(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [b = {}, E = [], w = void 0] = typeof n.extraReducers == "function" ? Fr(n.extraReducers) : [n.extraReducers], T = {
        ...b,
        ...l.sliceCaseReducersByType
      };
      return Qo(n.initialState, (D) => {
        for (let P in T)
          D.addCase(P, T[P]);
        for (let P of l.sliceMatchers)
          D.addMatcher(P.matcher, P.reducer);
        for (let P of E)
          D.addMatcher(P.matcher, P.reducer);
        w && D.addDefaultCase(w);
      });
    }
    const y = (b) => b, _ = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new WeakMap();
    let m;
    function v(b, E) {
      return m || (m = u()), m(b, E);
    }
    function O() {
      return m || (m = u()), m.getInitialState();
    }
    function k(b, E = !1) {
      function w(D) {
        let P = D[b];
        if (typeof P > "u") {
          if (E)
            P = Ie(h, w, O);
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? L(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return P;
      }
      function T(D = y) {
        const P = Ie(_, E, () => /* @__PURE__ */ new WeakMap());
        return Ie(P, D, () => {
          const U = {};
          for (const [K, le] of Object.entries(n.selectors ?? {}))
            U[K] = ri(le, D, () => Ie(h, D, O), E);
          return U;
        });
      }
      return {
        reducerPath: b,
        getSelectors: T,
        get selectors() {
          return T(w);
        },
        selectSlice: w
      };
    }
    const g = {
      name: i,
      reducer: v,
      actions: l.actionCreators,
      caseReducers: l.sliceCaseReducersByName,
      getInitialState: O,
      ...k(a),
      injectInto(b, {
        reducerPath: E,
        ...w
      } = {}) {
        const T = E ?? a;
        return b.inject({
          reducerPath: T,
          reducer: v
        }, w), {
          ...g,
          ...k(T, !0)
        };
      }
    };
    return g;
  };
}
function ri(e, t, r, n) {
  function i(a, ...c) {
    let s = t(a);
    if (typeof s > "u") {
      if (n)
        s = r();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? L(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(s, ...c);
  }
  return i.unwrapped = e, i;
}
var ni = /* @__PURE__ */ ti();
function oi() {
  function e(t, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...r
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...r) {
          return t(...r);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: r
      };
    },
    asyncThunk: e
  };
}
function ii({
  type: e,
  reducerName: t,
  createNotation: r
}, n, i) {
  let a, c;
  if ("reducer" in n) {
    if (r && !si(n))
      throw new Error(process.env.NODE_ENV === "production" ? L(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    a = n.reducer, c = n.prepare;
  } else
    a = n;
  i.addCase(e, a).exposeCaseReducer(t, a).exposeAction(t, c ? pr(e, c) : pr(e));
}
function ai(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function si(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function ci({
  type: e,
  reducerName: t
}, r, n, i) {
  if (!i)
    throw new Error(process.env.NODE_ENV === "production" ? L(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: a,
    fulfilled: c,
    pending: s,
    rejected: l,
    settled: d,
    options: u
  } = r, y = i(e, a, u);
  n.exposeAction(t, y), c && n.addCase(y.fulfilled, c), s && n.addCase(y.pending, s), l && n.addCase(y.rejected, l), d && n.addMatcher(y.settled, d), n.exposeCaseReducer(t, {
    fulfilled: c || je,
    pending: s || je,
    rejected: l || je,
    settled: d || je
  });
}
function je() {
}
function L(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const li = {
  mode: "2d",
  extent: void 0,
  zoom: void 0,
  scale: void 0,
  selectedPoint: null,
  locationHistory: [],
  highlightGeometries: null,
  disableMapClick: !1,
  selectedLocation: null
}, zr = ni({
  name: "map",
  initialState: li,
  reducers: {
    setMapMode(e, t) {
      e.mode = t.payload;
    },
    toggleMapMode(e) {
      e.mode = e.mode === "2d" ? "3d" : "2d";
    },
    setExtent(e, t) {
      const r = Ir(e).extent;
      (!r || Math.abs(r.xmin - (t.payload.extent?.xmin || 0)) > 1 || Math.abs(r.ymin - (t.payload.extent?.ymin || 0)) > 1 || Math.abs(r.xmax - (t.payload.extent?.xmax || 0)) > 1 || Math.abs(r.ymax - (t.payload.extent?.ymax || 0)) > 1) && (e.extent = t.payload.extent, e.zoom = t.payload.zoom, e.scale = t.payload.scale);
    },
    setSelectedPoint(e, t) {
      e.selectedPoint = t.payload;
    },
    addToLocationHistory(e, t) {
      t.payload.selected ? e.locationHistory.forEach((r) => r.selected = !1) : e.locationHistory.length === 0 && (t.payload.selected = !0), t.payload.id || (t.payload.id = crypto.randomUUID()), e.locationHistory.unshift(t.payload), e.locationHistory.length > 10 && e.locationHistory.pop(), e.selectedLocation = t.payload.selected ? t.payload : e.selectedLocation;
    },
    setLocationHistorySelected(e, t) {
      e.locationHistory.forEach((r) => {
        r.selected = r.id === t.payload, r.selected && (e.selectedLocation = r);
      });
    },
    setSelectedLocation(e, t) {
      if (t.payload) {
        e.locationHistory.forEach((n) => n.selected = !1);
        const r = e.locationHistory.find(
          (n) => n.x === t.payload.x && n.y === t.payload.y
        );
        r ? r.selected = !0 : (t.payload.id || (t.payload.id = crypto.randomUUID()), t.payload.selected = !0, e.locationHistory.unshift(t.payload), e.locationHistory.length > 10 && e.locationHistory.pop());
      }
      e.selectedLocation = t.payload;
    },
    setHighlightGeometries(e, t) {
      e.highlightGeometries = t.payload;
    },
    setDisableMapClick(e, t) {
      e.disableMapClick = t.payload;
    }
  }
}), {
  setMapMode: qa,
  toggleMapMode: Xa,
  setExtent: Qa,
  setSelectedPoint: Za,
  addToLocationHistory: es,
  setLocationHistorySelected: ts,
  setSelectedLocation: ui,
  setHighlightGeometries: rs,
  setDisableMapClick: di
} = zr.actions, ns = (e) => e.map.locationHistory, $r = (e) => e.map.disableMapClick, fi = (e) => e.map.selectedLocation;
Ot(
  (e) => e.map.highlightGeometries,
  (e) => e ? {
    geometries: e.geometries?.map((r) => Sr.fromJSON(r))?.filter((r) => r !== void 0),
    symbol: e.symbol,
    zoomTo: e.zoomTo
  } : null
);
Ot(
  (e) => e.map.locationHistory,
  (e) => {
    const t = e?.filter((r) => r.selected);
    return t && t.length === 1 ? t[0] : null;
  }
);
zr.reducer;
const Br = () => {
  const e = wo(), t = yt($r), r = yt(fi);
  return {
    disableMapClick: t,
    selectedLocation: r,
    setDisableMapClick: (n) => e(di(n)),
    setSelectedLocation: (n) => e(ui(n))
  };
}, os = () => yt($r);
new Ln({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapAdmin/MapServer",
  title: "Administrative enheter",
  visible: !1
});
const pi = new Cr({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapGeoEiendom/MapServer/15",
  title: "Eiendomsgrenser",
  visible: !0,
  id: "Eiendomsgrenser"
}), yr = new Cr({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapGeoEiendom/MapServer/7",
  title: "Eiendommer",
  visible: !0,
  id: "Eiendommer",
  listMode: "hide",
  renderer: new Bn({
    symbol: new Gn({
      color: [0, 0, 0, 0],
      outline: { color: [0, 0, 0, 0], width: 0 }
    })
  })
});
new zn({
  layers: [
    new Fn({
      url: "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheTerreng/ImageServer"
    })
  ],
  navigationConstraint: { type: "stay-above" }
});
new Vn({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geoscene/GeosceneBygning2/SceneServer",
  minScale: 2e4,
  title: "Bygninger",
  popupEnabled: !1
});
const mi = new Z({
  baseLayers: [
    new me({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
    })
  ],
  id: "basis_terreng",
  thumbnailUrl: "images/basis terreng.png"
}), yi = new Z({
  baseLayers: [
    new me({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatoneTerreng_UTM32/VectorTileServer"
    })
  ],
  id: "graatone_terreng",
  thumbnailUrl: "images/gråtone terreng.png"
}), hi = new Z({
  baseLayers: [
    new me({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheKanvasMork_UTM32/VectorTileServer"
    })
  ],
  id: "mork",
  thumbnailUrl: "images/kanvas mørk.png"
}), gi = new Z({
  baseLayers: [
    // Gir visningen et vektorbasert (i praksis ubegrenset) LOD-skjema, slik at
    // kartet ikke låses til flyfoto-tjenestens cachede maks-zoom (1:625).
    new me({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatoneTerreng_UTM32/VectorTileServer"
    }),
    new jn({
      url: "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM32_EUREF89/GeocacheBilder/MapServer"
    })
  ],
  id: "bilder",
  thumbnailUrl: "images/bilder.png"
}), Ee = new $n({
  basemaps: [mi, yi, gi, hi]
}), bi = new Rr({
  url: "https://services.geodataonline.no/arcgis/rest/services/ProxyServices/Adresse/GeocodeServer",
  singleLineFieldName: "SingleLine",
  name: "Adressesøk",
  placeholder: "",
  // i18next.t("search.placeholder", {ns: "map"}),
  maxResults: 3,
  maxSuggestions: 6,
  suggestionsEnabled: !0,
  minSuggestCharacters: 2,
  zoomScale: 5e3,
  popupEnabled: !1
}), vi = new Rr({
  url: "https://services.geodataonline.no/arcgis/rest/services/ProxyServices/Adresse__filter_kilde-eiendom/GeocodeServer",
  singleLineFieldName: "SingleLine",
  name: "Eiendomssøk",
  placeholder: "",
  // i18next.t("search.placeholder", {ns: "map"}),
  maxResults: 3,
  maxSuggestions: 6,
  suggestionsEnabled: !0,
  minSuggestCharacters: 2,
  zoomScale: 5e3,
  popupEnabled: !1
});
function _i(e) {
  const t = Ee.basemaps.at(0);
  t && (t.title = e.t("basemaps.basis", { ns: "map" }));
  const r = Ee.basemaps.at(1);
  r && (r.title = e.t("basemaps.graatone", { ns: "map" }));
  const n = Ee.basemaps.at(2);
  n && (n.title = e.t("basemaps.bilder", { ns: "map" }));
  const i = Ee.basemaps.at(3);
  i && (i.title = e.t("basemaps.mork", { ns: "map" }));
}
const oe = Re("MapInit"), Ei = ({
  containerRef: e,
  mapMode: t,
  webMapId: r,
  webSceneId: n,
  basemapConfig: i,
  disablePopup: a,
  initialView: c,
  includeEiendomsGrenseLayer: s = !0,
  includeEiendomsTeigLayer: l = !0,
  onMapViewCreated: d,
  onSceneViewCreated: u
}) => {
  const y = te(null), _ = te(c);
  return W(() => {
    if (!e.current)
      return;
    let h = null, m = !1;
    const v = [
      { layer: pi, enabled: s },
      { layer: yr, enabled: l }
    ];
    return (async () => {
      let k;
      if (t === Fe.TwoD) {
        if (r)
          oe.debug("Initializing 2D MapView with webMap", r), k = new Pn({
            portalItem: {
              id: r
            }
          });
        else {
          oe.debug("Initializing 2D MapView with basemap config");
          const b = i ? new Z(i) : new Z({
            baseLayers: [
              new me({
                url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
              })
            ],
            id: "basis_terreng",
            title: "Basis Terreng"
          });
          k = new qt({
            basemap: b
          });
        }
        y.current = k, oe.debug("Map instance created for 2D view");
        const g = _.current;
        h = new Nn({
          container: e.current,
          map: k,
          popupEnabled: !a,
          ...g && {
            center: new kr({ x: g.x, y: g.y, spatialReference: { wkid: g.wkid } }),
            zoom: g.zoom
          }
        }), h.when(() => {
          !m && d && (d(h), l && (yr.outFields = ["id", "objectid", "gids"]), v.forEach(({ layer: b, enabled: E }) => {
            E && h?.map?.add(b);
          }));
        }).catch((b) => {
          oe.error("MapView failed to load:", b);
        });
      } else {
        if (n)
          oe.debug("Initializing 3D SceneView with webScene", n), k = new An({
            portalItem: {
              id: n
            }
          });
        else {
          oe.debug("Initializing 3D SceneView with basemap config");
          const g = i ? new Z(i) : new Z({
            baseLayers: [
              new me({
                url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
              })
            ],
            id: "basis_terreng",
            title: "Basis Terreng"
          });
          k = new qt({
            basemap: g
          });
        }
        y.current = k, h = new In({
          container: e.current,
          map: k,
          popupEnabled: !a,
          center: [10.7522, 59.9139],
          zoom: 10
        }), h.when(() => {
          !m && u && u(h);
        }).catch((g) => {
          oe.error("SceneView failed to load:", g);
        });
      }
    })(), () => {
      m = !0;
      const k = y.current;
      if (k) {
        try {
          v.forEach(({ layer: g, enabled: b }) => {
            b && k.layers?.remove(g);
          });
        } catch {
        }
        try {
          k.basemap = null;
        } catch {
        }
      }
      y.current = null, h && !h.destroyed && h.destroy();
    };
  }, [t, e, r, n, i, s, l, d, u]), { mapRef: y };
};
function wi(e) {
  const t = {
    position: "absolute",
    top: e.top || "0px",
    left: e.left || "0px",
    border: "none",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 2px"
  };
  return /* @__PURE__ */ X.jsx(
    "input",
    {
      style: t,
      className: e.class,
      type: "button",
      id: e.id,
      value: e.value,
      onClick: e.onClick
    }
  );
}
var j = /* @__PURE__ */ ((e) => (e.PropertyInfo = "propertyinformation", e.Planinformasjon = "planinformation", e.ShowArealplaner = "show-arealplaner", e.ToggleArealplaner = "toggle-arealplaner", e))(j || {});
const Gr = "Arealplaner", Wr = (e) => {
  let t = `${e.gardsnr}/${e.bruksnr}`;
  return e.festenr && (t += `/${e.festenr}`), e.seksjonsnr && (t += `/${e.seksjonsnr}`), t;
}, Ur = (e, t, r, n) => ({
  selected: !0,
  name: e,
  address: t.adresse || "",
  postalCode: "",
  postalArea: "",
  x: r.x,
  y: r.y,
  wkid: n.spatialReference.wkid ?? void 0,
  source: "mapClick",
  matrikkelEnhet: {
    gardsnr: t.gardsnr,
    bruksnr: t.bruksnr,
    festenr: t.festenr,
    seksjonsnr: t.seksjonsnr,
    kommunenr: String(t.kommunenr),
    kommunenavn: t.kommunenavn
  }
}), Hr = (e, t, r) => `Grunneiendom ${e} i ${t || ""} kommune (${r || ""})`, Yr = (e) => {
  if (!(e.gardsnr === void 0 || e.bruksnr === void 0))
    return {
      gardsnr: Number(e.gardsnr),
      bruksnr: Number(e.bruksnr),
      festenr: e.festenr ? Number(e.festenr) : void 0,
      seksjonsnr: e.seksjonsnr ? Number(e.seksjonsnr) : void 0,
      kommunenr: String(e.kommunenr),
      kommunenavn: String(e.kommunenavn)
    };
};
var Kr = /* @__PURE__ */ ((e) => (e.PLAN_ID = "PLANID", e.PLAN_NAVN = "PLANNAVN", e.PLAN_TYPE = "PLANTYPE", e.PLAN_STATUS = "PLANSTAT", e.PLAN_BESTEMMELSER = "PLANBEST", e.IKRAFTTREDELSESDATO = "IKRAFT", e.LOVREFERANSE = "LOVREFERANSE", e.PLAN_REGISTER_LINK = "PLANREGISTERLINK", e.VERTIKALNIVÅ = "VERTNIV", e.OBJTYPE = "OBJTYPE", e))(Kr || {});
const Si = Re("popupUtils"), ki = (e, t) => !e || e === "null" ? t === "Eiendom" ? "" : "Eiendommen har flere adresser" : `Tilknyttet adresse: ${e}`, Jr = (e, t, r, n, i) => {
  const a = ki(t, n), c = "Benytt knappene i verktøylinjen for å se matrikkelinformasjon om eiendommen og alle arealplaner som berører eiendommen";
  return e ? !r || Object.keys(r).length === 0 ? `
        <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
          <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">${i}</div>
          <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin-bottom: 8px;">${a}</div>
          <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin: 12px 0 8px 0;">Finner ingen arealplaner i kartet</div>
          <div style="font-size: 0.75rem; color: #666; line-height: 1.4;">${c}</div>
        </div>
        ` : `
    <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
        <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">${i}</div>
        <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin-bottom: 8px;">${a}</div>
        <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin: 12px 0 8px 0;">Arealplaner vist i kartet</div>
  
      <div>
        ${Object.entries(r).map(([s, l]) => {
    const d = l.attributes.PLANNAVN;
    return `
            <div style="margin: 0.5rem 0; padding: 0.5rem; background-color: white; border-radius: 4px; box-shadow: 0 1px 2px rgba(0,0,0,0.05); border: 1px solid #eee;">
              <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.9rem; color: #333;">
                <div>
                  <a href="${l.attributes.PLANREGISTERLINK}" target="_blank" style="color: #0066cc; text-decoration: none; font-weight: 500; border-bottom: 1px solid #0066cc;">${d ? `${d} (${s})` : s}</a>
                </div>
              </div>
            </div>
          `;
  }).join("")}
      </div>
    <div style="margin-top: 12px; font-size: 0.75rem; color: #666; line-height: 1.4;">${c}</div>
    </div>
  ` : `
        <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
          <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">En feilsituasjon har oppstått, prøv igjen senere</div>
        </div>
        `;
}, Ri = (e, t) => {
  const r = e.graphic.attributes[Kr.PLAN_ID];
  if (r) {
    t[r] || (t[r] = { PLANID: r, attributes: {} });
    for (const [n, i] of Object.entries(e.graphic.attributes))
      t[r].attributes[n] = i;
  }
  return t;
}, Ci = (e) => e.reduce(
  (t, r) => Ri(r, t),
  {}
), Ti = (e) => e.filter(
  (t) => t.layer.type === "vector-tile" && t.type === "graphic"
), qr = async (e, t) => {
  try {
    const r = await e.hitTest(t);
    if (r.results.length) {
      const n = Ti(r.results);
      return Ci(n);
    }
  } catch (r) {
    Si.error(r.message);
  }
}, Ke = (e) => e.map?.allLayers.find((t) => t.title === Gr), Mt = (e, t) => e.popup?.actions.find((r) => r.id === t), xi = (e, t) => {
  if (e.map)
    for (const r of e.map.allLayers)
      r.parent && "title" in r.parent && r.parent.title === t && (r.visible = !0);
}, Oi = (e, t) => {
  let r = e.adresseid || e.Match_addr, n = e.Match_addr, i = "";
  return e.gatenavn && (i = `${e.gatenavn} ${e.husnrbokstav}`, n = `${i}, ${e.postnr} ${e.poststed}`), {
    selected: !0,
    id: r,
    name: n,
    address: i,
    postalCode: e.postnr || "",
    postalArea: e.poststed || "",
    x: e.x,
    y: e.y,
    wkid: 25833,
    matrikkelEnhet: t
  };
}, Mi = Re("widgetUtils"), Di = (e) => {
  e.ui.find("location-analytics-fullscreen") || e.ui.add(new qn({
    id: "location-analytics-fullscreen",
    view: e
  }), { position: "top-right" });
}, Pi = async (e) => {
  try {
    const t = await e.takeScreenshot(), n = await (await fetch(t.dataUrl)).blob();
    await navigator.clipboard.write([
      new ClipboardItem({
        [n.type]: n
      })
    ]);
  } catch (t) {
    Mi.error("Failed to copy screenshot to clipboard:", t);
  }
}, Ai = (e) => {
  if (!e.ui.find("location-analytics-copymap")) {
    const r = document.createElement("input");
    r.id = "location-analytics-copymap", r.type = "button", r.className = "esri-component esri-widget--button esri-widget esri-interactive", r.onclick = () => Pi(e), e.ui.add(r, { position: "top-right" });
  }
}, Ni = (e) => {
  e.ui.find("location-analytics-basemaps") || e.ui.add(new We({
    id: "location-analytics-basemaps",
    view: e,
    content: new Un({
      view: e,
      source: Ee
    }),
    expandTooltip: "Bakgrunnskart",
    autoCollapse: !0,
    closeOnEsc: !0
  }), { position: "bottom-left" });
}, Ii = (e, t) => {
  if (!e.ui.find("location-analytics-measure")) {
    const n = new We({
      id: "location-analytics-measure",
      view: e,
      content: e.type === "3d" ? new Yn({ view: e }) : new Hn({ view: e })
    });
    e.ui.add(n, { position: "top-right" }), re.when(() => n.expanded === !1, () => {
      n.content.viewModel.clear();
    });
    const i = re.watch(() => n.expanded, (a) => {
      a ? t(!0) : (t(!1), n.content.viewModel.clear());
    });
    n.addHandles(i);
  }
}, ji = (e) => {
  if (!e.ui.find("location-analytics-daylight") && e.type === "3d") {
    const r = new We({
      id: "location-analytics-daylight",
      view: e,
      content: new Kn({
        view: e
      })
    });
    e.ui.add(r, { position: "top-right" });
  }
}, Li = (e) => {
  if (!e.ui.find("location-analytics-shadow") && e.type === "3d") {
    const r = new We({
      id: "location-analytics-shadow",
      view: e,
      expandIcon: "measure-building-height-shadow"
    });
    e.ui.add(r, { position: "top-right" }), re.watch(() => r.expanded, (n) => {
      n ? r.content = new Jn({
        view: e
      }) : r.content && r.content.destroy();
    });
  }
}, Vi = (e) => {
  e.ui.find("location-analytics-scalebar") || e.ui.add(new Xn({
    view: e,
    unit: "metric"
  }), { position: "bottom-left" });
}, Fi = (e, t) => {
  e.popup?.actions.push(new Le({
    title: t("popup.property"),
    id: j.PropertyInfo,
    icon: "locator"
  })), e.popup?.actions.push(new Le({
    title: "Arealplaner for eiendommen",
    id: j.Planinformasjon,
    icon: "classify-objects"
  }));
}, zi = (e) => {
  const t = Ke(e), r = t?.visible ?? !1;
  if (e.popup?.actions.push(new Le({
    title: "Arealplaner",
    id: j.ToggleArealplaner,
    icon: r ? "view-visible" : "view-hide"
  })), e.popup?.actions.push(new Le({
    title: "Vis alle arealplaner",
    id: j.ShowArealplaner,
    icon: "show-multiple-layers-at-a-time"
  })), t) {
    const n = re.watch(
      () => t.visible,
      (i) => {
        const a = Mt(e, j.ToggleArealplaner);
        a && (a.icon = i ? "view-visible" : "view-hide");
      }
    );
    e.addHandles(n, "arealplaner-visibility");
  }
}, $i = (e) => {
  const t = re.on(
    () => e.popup,
    "open",
    () => {
      const n = Ke(e);
      if (n) {
        const i = Mt(e, j.ToggleArealplaner);
        i && (i.icon = n.visible ? "view-visible" : "view-hide");
      }
    }
  );
  e.addHandles(t, "location-analytics");
  const r = re.on(
    () => e.popup,
    "close",
    () => {
      e.removeHandles("arealplaner-visibility");
    }
  );
  e.addHandles(r, "location-analytics");
}, Bi = (e, t, r, n) => {
  const i = Ke(e);
  if (!i)
    return !1;
  const a = i.visible;
  return i.visible = !a, t.action.title = "Arealplaner", t.action.icon = a ? "view-hide" : "view-visible", r ? (e.popup?.close(), n(e, r, !1), !0) : !1;
}, Gi = (e, t, r) => {
  const n = Ke(e);
  if (!n)
    return !1;
  xi(e, Gr), n.visible = !0;
  const i = Mt(e, j.ToggleArealplaner);
  return i && (i.title = "Arealplaner", i.icon = "view-visible"), t ? (e.popup?.close(), r(e, t, !1), !0) : !1;
}, ye = Re("mapUtils"), Wi = async (e, t, r, n, i) => {
  const a = e.matrikkelInfo, c = Wr(a), s = a.adresse || e?.address || "", l = Hr(c, a.kommunenavn, a.kommunenr);
  if (i) {
    const u = Ur(c, a, t, r);
    i(u);
  }
  const d = await qr(r, n);
  return { matrikkelEnhet: c, adresse: s, heading: l, planer: d };
}, Ui = async (e, t, r, n, i, a) => {
  const c = a ? a.getMatrikkelEnhetFromGeometry(e) : Promise.resolve([]), s = qr(t, r), l = await Promise.allSettled([c, s]), d = l[0], u = l[1];
  let y = "", _ = n?.address || "", h = n?.name || "Resultat", m;
  if (d.status === "fulfilled" && d.value.length > 0) {
    const v = d.value[0];
    if (y = Wr(v), _ = v.adresse || _, h = Hr(y, v.kommunenavn, v.kommunenr), i) {
      const O = Ur(y, v, e, t);
      i(O);
    }
  } else
    n && (y = n.name || "");
  return u.status === "fulfilled" && (m = u.value), { matrikkelEnhet: y, adresse: _, heading: h, planer: m };
}, Dt = async (e, t, r, n, i, a, c) => {
  try {
    let s;
    n?.matrikkelInfo ? s = await Wi(
      n,
      t,
      e,
      r,
      a
    ) : s = await Ui(
      t,
      e,
      r,
      n,
      a,
      c
    );
    const { matrikkelEnhet: l, adresse: d, heading: u, planer: y } = s;
    return i || e.openPopup({
      title: "Resultat fra søk",
      content: Jr(l, d, y, n?.searchType, u),
      location: t
    }), { matrikkelEnhet: l, adresse: d, planer: y };
  } catch (s) {
    throw ye.error("Feil under behandling av lokasjon:", s), s;
  }
}, St = (e, t, r, n, i) => {
  const a = e.on("click", function(c) {
    if (n())
      return;
    const l = document.getElementById("origo-map-container");
    l && (l.style.cursor = "wait"), Dt(
      e,
      c.mapPoint,
      c,
      void 0,
      t,
      r,
      i
    ).catch((d) => {
      ye.error("Feil under behandling av klikk:", d);
    }).finally(() => {
      l && (l.style.cursor = "default");
    });
  });
  e.addHandles(a, "location-analytics");
}, hr = async (e, t, r) => {
  if (r)
    return;
  const n = new kr({
    x: t.x,
    y: t.y,
    spatialReference: { wkid: t.wkid || e.spatialReference.wkid }
  }), i = e.toScreen(n);
  if (!i) {
    ye.error("Kunne ikke konvertere punkt til skjermkoordinater");
    return;
  }
  try {
    await Dt(
      e,
      n,
      i,
      {
        name: t.name,
        address: t.address,
        matrikkelInfo: t.matrikkelEnhet ? {
          gardsnr: t.matrikkelEnhet.gardsnr,
          bruksnr: t.matrikkelEnhet.bruksnr,
          festenr: t.matrikkelEnhet.festenr,
          seksjonsnr: t.matrikkelEnhet.seksjonsnr,
          kommunenr: t.matrikkelEnhet.kommunenr || "",
          kommunenavn: t.matrikkelEnhet.kommunenavn || ""
        } : void 0
      },
      r
    );
  } catch (a) {
    ye.error("Feil under åpning av popup:", a);
  }
}, Hi = (e) => e?.includes(j.PropertyInfo) ?? !1, gr = (e, t, r, n, i, a = !1) => {
  re.when(() => e.popup?.actions, () => {
    const s = e.popup?.actions.filter(
      (l) => l.id === j.PropertyInfo || l.id === j.Planinformasjon || l.id === j.ShowArealplaner
    );
    s && s.length > 0 || (e.popup?.viewModel && (e.popup.viewModel.includeDefaultActions = !1), e.popup && (e.popup.dockOptions.position = "bottom-right"), Hi(t) && Fi(e, i), a || zi(e));
  }), a || $i(e);
  const c = re.on(
    () => e.popup,
    "trigger-action",
    (s) => {
      if (s.action.id === j.PropertyInfo)
        r({ widgetId: j.PropertyInfo, keepOpen: !0, layoutPosition: "left" });
      else if (s.action.id === j.Planinformasjon)
        r({ widgetId: j.Planinformasjon, keepOpen: !0, layoutPosition: "left" });
      else if (!a && s.action.id === j.ToggleArealplaner) {
        if (Bi(e, s, n(), hr))
          return;
      } else if (!a && s.action.id === j.ShowArealplaner && Gi(e, n(), hr))
        return;
      e.popup?.close();
    }
  );
  e.addHandles(c, "location-analytics");
}, Yi = (e, t, r, n) => {
  n || e.openPopup({
    title: "Søkeresultat",
    content: Jr(t),
    location: r
  });
}, Ki = (e, t, r, n, i, a) => {
  const c = e.toScreen(t);
  if (!c)
    return;
  const s = Yr(r), l = s ? {
    ...s,
    adresse: i
  } : void 0;
  Dt(
    e,
    t,
    c,
    {
      name: n,
      address: i,
      isSearchResult: !0,
      searchType: r.Addr_type,
      matrikkelInfo: l
    },
    a
  ).catch((d) => {
    ye.error("Feil under behandling av søkeresultat:", d);
  });
}, br = (e, t, r = !1, n = !1) => {
  const i = e.ui.find("location-analytics-search");
  if (r) {
    i && e.ui.remove(i);
    return;
  } else if (i)
    return;
  const a = new Wn({
    id: "location-analytics-search",
    view: e,
    sources: [bi, vi],
    includeDefaultSources: !1,
    locationEnabled: !1
  });
  e.ui.add(a, { position: "top-right", index: 0 });
  const c = a.on("select-result", function(s) {
    const l = s.result.feature.attributes, d = Yr(l), u = Oi(l, d);
    if (t(u), l.Addr_type === "Stedsnavn") {
      Yi(e, u.name, s.result.feature.geometry, n);
      return;
    }
    Ki(
      e,
      s.result.feature.geometry,
      l,
      u.name,
      u.address,
      n
    );
  });
  a.addHandles(c, "location-analytics");
}, vr = (e, t, r) => {
  t && (t.includes("fullscreen") && Di(e), t.includes("copymap") && Ai(e), t.includes("basemaps") && Ni(e), t.includes("measure") && Ii(e, r), t.includes("daylight") && ji(e), t.includes("shadow") && Li(e), t.includes("scalebar") && Vi(e));
}, _r = (e, t) => {
  if (t)
    for (const r of t) {
      const n = e.ui.find("location-analytics-" + r);
      if (n) {
        e.ui.remove(n);
        try {
          n.destroy();
        } catch (i) {
          ye.warn(`Failed to destroy widget ${r}:`, i);
        }
      }
    }
}, Er = (e) => {
  e.popup && (e.popup.dockEnabled = !0, e.popup.dockOptions = {
    buttonEnabled: !0,
    breakpoint: !0,
    position: "bottom-right"
  });
}, ft = Re("Map");
function is(e) {
  const { t } = Mn("map"), {
    disableMapClick: r,
    selectedLocation: n,
    setDisableMapClick: i,
    setSelectedLocation: a
  } = Br(), c = te(null), s = te(r);
  W(() => {
    s.current = r;
  }, [r]);
  const {
    mapView: l,
    sceneView: d,
    mapMode: u,
    toggleMapMode: y,
    setMapView: _,
    setSceneView: h
  } = yo();
  Ei({
    containerRef: c,
    mapMode: u,
    webMapId: e.webMapId,
    webSceneId: e.webSceneId,
    disablePopup: e.disablePopup,
    initialView: e.initialView,
    includeEiendomsGrenseLayer: e.includeEiendomsGrenseLayer,
    includeEiendomsTeigLayer: e.includeEiendomsTeigLayer,
    onMapViewCreated: _,
    onSceneViewCreated: h
  }), W(() => {
    e.disable3D && u === Fe.ThreeD && y();
  }, [e.disable3D, u, y]), W(() => {
    if (ft.debug("MapView setup effect, mapView ready:", !!l), !!l)
      return l.aria = {
        label: t("mapAriaLabel"),
        description: t("mapInstructions")
      }, Er(l), br(
        l,
        a,
        e.disableSearch,
        e.disablePopup
      ), vr(l, e.tools2D, i), e.disableClick || (ft.debug("Adding view click handler"), St(
        l,
        e.disablePopup,
        a,
        () => s.current,
        e.matrikkelClient
      )), e.widgetItems && e.onActiveWidgetChange && gr(
        l,
        e.widgetItems.map((v) => v.widget),
        e.onActiveWidgetChange,
        () => n ?? void 0,
        t,
        !0
      ), () => {
        ft.debug("Cleaning up mapView"), l.removeHandles("location-analytics"), e.tools2D && _r(l, e.tools2D);
      };
  }, [
    l,
    e.disableSearch,
    e.disablePopup,
    e.disableClick,
    e.tools2D,
    e.matrikkelClient,
    a,
    i,
    t
  ]), W(() => (d && (d.aria = {
    label: t("mapAriaLabel"),
    description: t("mapInstructions")
  }, Er(d), br(
    d,
    a,
    e.disableSearch,
    e.disablePopup
  ), vr(d, e.tools3D, i), St(
    d,
    e.disablePopup,
    a,
    () => s.current,
    e.matrikkelClient
  ), e.widgetItems && e.onActiveWidgetChange && gr(
    d,
    e.widgetItems.map((v) => v.widget),
    e.onActiveWidgetChange,
    () => n ?? void 0,
    t,
    !0
  )), () => {
    d && (d.removeHandles("location-analytics"), e.tools3D && _r(d, e.tools3D));
  }), [
    d,
    e.disableSearch,
    e.disablePopup,
    e.tools3D,
    e.widgetItems,
    e.onActiveWidgetChange,
    a,
    i,
    t
  ]);
  const m = () => {
    y();
  };
  return /* @__PURE__ */ X.jsxs("div", { className: "map-container", children: [
    /* @__PURE__ */ X.jsx("div", { id: "origo-map-container", className: "esri-map-container", role: "region", "aria-label": t("mapAriaLabel"), ref: c }),
    !e.disable3D && /* @__PURE__ */ X.jsxs(X.Fragment, { children: [
      /* @__PURE__ */ X.jsx(
        wi,
        {
          top: "10px",
          left: "55px",
          class: "esri-component esri-widget--button esri-widget esri-interactive",
          id: "map-mode-toggle-button",
          value: u === Fe.TwoD ? "3D" : "2D",
          onClick: m
        }
      ),
      /* @__PURE__ */ X.jsx(Dn, { referenceElement: "map-mode-toggle-button", placement: "right", children: t("toggleModeTooltip") })
    ] }),
    e.children
  ] });
}
const as = (e, t, r) => {
  const { disableMapClick: n, setSelectedLocation: i } = Br(), a = te(() => n);
  W(() => {
    a.current = () => n;
  }, [n]), W(() => {
    if (e)
      return St(
        e,
        t,
        i,
        () => a.current(),
        // Always get fresh value
        r
      ), () => {
        e.removeHandles("location-analytics");
      };
  }, [e, t, i, r]);
};
let wr = !1;
function ss(e) {
  if (wr)
    return;
  wr = !0;
  const t = () => {
    e.hasResourceBundle(e.language, "map") && _i(e);
  };
  e.isInitialized && t(), e.on("initialized", t), e.on("languageChanged", t), e.on("loaded", t);
}
const Ji = "Toggle between 2D and 3D view", qi = "Map", Xi = "Use the arrow keys to pan the map and the plus/minus keys to zoom in and out.", Qi = {
  basis: "Standard",
  graatone: "Grayscale",
  bilder: "Imagery",
  mork: "Dark"
}, Zi = {
  placeholder: "Address or place..."
}, ea = {
  huff: "Establishment analysis",
  property: "Property info",
  analysis: "Analysis area",
  streetview: "StreetView"
}, ta = {
  filterPlaceholder: "Search for map layers..."
}, ra = {
  toggleModeTooltip: Ji,
  mapAriaLabel: qi,
  mapInstructions: Xi,
  basemaps: Qi,
  search: Zi,
  popup: ea,
  layerlist: ta
}, na = "Bytt mellom 2D- og 3D-visning", oa = "Kart", ia = "Bruk piltastene for å panorere kartet og pluss/minus-tastene for å zoome inn og ut.", aa = {
  basis: "Fargekart",
  graatone: "Gråtone",
  bilder: "Bilder",
  mork: "Mørkt"
}, sa = {
  placeholder: "Adresse eller sted..."
}, ca = {
  huff: "Etableringsanalyse",
  property: "Eiendomsinformasjon",
  analysis: "Analyseområde",
  streetview: "Gatebilder"
}, la = {
  filterPlaceholder: "Søk etter kartlag..."
}, ua = {
  toggleModeTooltip: na,
  mapAriaLabel: oa,
  mapInstructions: ia,
  basemaps: aa,
  search: sa,
  popup: ca,
  layerlist: la
}, cs = {
  nb: {
    map: ua
  },
  en: {
    map: ra
  }
};
export {
  Gr as AREALPLANER_LAYER_NAME,
  is as Map,
  Fe as MapMode,
  j as MapPopupActions,
  wi as MapTool,
  Ua as MapViewProvider,
  es as addToLocationHistory,
  St as addViewClickHandler,
  Ee as basemaps,
  Er as configurePopup,
  po as goToWithInset,
  Ka as highlightedAreaSymbol,
  ss as initMapContext,
  zr as mapSlice,
  cs as mapTranslation,
  Ja as secondaryPolygonSymbol,
  $r as selectDisableMapClick,
  ns as selectLocationHistory,
  fi as selectSelectedLocation,
  Ya as selectedPointSymbol,
  Ha as selectedPolygonSymbol,
  di as setDisableMapClick,
  rs as setHighlightGeometries,
  ui as setSelectedLocation,
  _i as updateBasemapTitles,
  os as useDisableMapClick,
  as as useMapClickHandler,
  Br as useMapState,
  yo as useMapViewContext
};
//# sourceMappingURL=index.mjs.map
